module.exports = __webpack_public_path__ + "static/media/d7ru.a1a9052c.pdf";